module.exports = "\r\n<app-home></app-home>"